function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { genComponentStyleHook } from "../../_util/genComponentStyleHook";
export var genButtonStyle = function genButtonStyle(token) {
  var componentCls = token.componentCls;
  // primary button className
  var primaryBtnCls = "".concat(componentCls).concat(componentCls, "-primary:not([disabled]):not(").concat(componentCls, "-disabled):not(").concat(componentCls, "-dangerous):not(").concat(componentCls, "-background-ghost)");
  var primaryAndCompactItemBtnCls = "".concat(componentCls, "-compact-item").concat(primaryBtnCls);
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(componentCls), {
    // remove box-shadow for button
    boxShadow: 'none !important'
  }), "".concat(primaryBtnCls), _defineProperty(_defineProperty({
    background: 'linear-gradient(-59deg, #002BFF 0%, #0080FF 100%)',
    border: 'none'
  }, '&:hover', {
    background: 'linear-gradient(120deg, #1AA0FF 0%, #1A53FF 100%)'
  }), '&:active', {
    background: 'linear-gradient(120deg, #0060E6 0%, #0013E6 100%)'
  })), "".concat(primaryBtnCls).concat(componentCls, "-compact-last-item"), _defineProperty(_defineProperty({
    background: 'linear-gradient(-59deg, #002BFF 0%, #002BFF 100%)'
  }, '&:hover', {
    background: 'linear-gradient(120deg, #1AA0FF 0%, #1A53FF 100%)'
  }), '&:active', {
    background: 'linear-gradient(120deg, #0060E6 0%, #0013E6 100%)'
  })), "".concat(primaryAndCompactItemBtnCls, "+").concat(primaryAndCompactItemBtnCls, ":before"), {
    height: '100%',
    top: 0
  }), "".concat(primaryAndCompactItemBtnCls, ":hover"), {
    zIndex: 0
  });
};
export default (function (prefixCls, isAliyun) {
  var useStyle = genComponentStyleHook('Button', function (token) {
    return isAliyun ? [] : [genButtonStyle(token)];
  });
  return useStyle(prefixCls);
});